module.exports = __webpack_public_path__ + "static/media/Tennis1.bdc584ec.glb";